import styled, { keyframes } from "styled-components";

export const NotifyContainer = styled.div`
  min-height: 100vh;
  padding-bottom: 50px;
  .inner {
    max-width: 1440px;
    padding: 0 20px;
    letter-spacing: -1px;
    margin: auto;
  }
`;

export const NotifHeaderContainer = styled.div`
  .inner {
    max-width: 1440px;
    padding: 10px 20px;
    min-height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      font-size: 22px;
      color: #000;
      font-weight: 700;
      height: auto;
    }
    .toggle {
      button {
        border: none;
        background: transparent;
      }
      .cancel {
        font-size: 14px;
      }
      .setting {
        display: flex;
        gap: 10px;
        position: relative;
        > button {
          font-size: 28px;
          display: flex;
          align-items: center;
        }
        ul {
          font-size: 12px;
          position: absolute;
          background: #fff;
          bottom: 0;
          right: 0;
          transform: translateY(100%);
          width: 100px;
          border: 1px solid #989898;
          text-align: center;
          border-radius: 5px;
          li {
            padding: 5px 0;
            border-bottom: 1px solid #989898;
            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
`;

export const Not = styled.div`
  margin-top: 50px;
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #a7a7a7;
  background: #eeeeee;
  font-size: 18px;
  border-radius: 10px;
  gap: 15px;
  svg {
    font-size: 30px;
    margin: 0;
  }
  @media screen and (max-width: 1050px) {
    height: 300px;
    font-size: 16px;
    svg {
      font-size: 24px;
    }
  }
  @media screen and (max-width: 767px) {
    height: 200px;
    font-size: 12px;
    svg {
      font-size: 20px;
    }
  }
`;

export const NotifListContainer = styled.ul`
  li {
    &.read {
      opacity: 0.5;
    }
    &.unread {
      opacity: 1;
    }
    border-radius: 20px;
    padding: 15px;
    box-sizing: border-box;
    margin: 10px 0;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0 20px;
    position: relative;
    width: 100%;
    font-size: 16px;
    img {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      border: 1px solid #efefef;
      object-fit: contain;
    }
    .cont {
      width: calc(100% - 150px);
      .info {
        display: flex;
        gap: 10px;
        align-items: center;
      }
      .date,
      span:first-child {
        color: #999;
        font-size: 14px;
      }
      span:first-child {
        margin-bottom: 5px;
        display: inline-block;
      }
    }
    label {
      width: 30px;
      height: 30px;
      position: relative;
      .checkmark::after {
        width: 14px;
        height: 24px;
        border-width: 0px 5px 5px 0px;
      }
    }
    .actions {
      width: 100%;
      display: flex;
      justify-content: center;
      gap: 20px;
      align-items: center;
      overflow: hidden;
      transition: 0.3s;
      height: 0;
      padding: 0;
      button {
        max-width: 350px;
        width: calc(50% - 10px);
        border-radius: 10px;
        border: none;
        height: 40px;
        font-size: 14px;
        background: #efefef;
        margin-top: 20px;
        &:first-child {
          background: #1a6cff;
          color: #fff;
        }
        &:last-child {
          background: #eeeeee;
          color: #a7a7a7;
        }
      }
      &.active {
        height: 60px;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    li {
      font-size: 14px;
      .cont {
        .date,
        span:first-child {
          font-size: 12px;
        }
      }
      label {
        width: 25px;
        height: 25px;
        .checkmark::after {
          width: 10px;
          height: 18px;
          border-width: 0px 4px 4px 0px;
        }
      }
      .actions {
        &.active {
          height: 50px;
        }
        button {
          max-width: none;
          height: 30px;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    li {
      gap: 0 10px;
      font-size: 12px;
      padding: 10px;
      border-radius: 10px;
      &.delete {
        .cont {
          width: calc(100% - 90px);
        }
      }
      label {
        width: 20px;
        height: 20px;
        .checkmark::after {
          width: 8px;
          height: 14px;
          border-width: 0px 3px 3px 0px;
        }
      }
      img {
        width: 50px;
        height: 50px;
      }
      .cont {
        width: calc(100% - 60px);
        .info {
          display: block;
        }
        .date,
        span:first-child {
          font-size: 10px;
          display: block;
          margin-bottom: 5px;
        }
      }
      .actions {
        gap: 10px;
        button {
          width: calc(50% - 5px);
          font-size: 12px;
        }
      }
    }
  }
`;

export const NotifTabMenu = styled.ul`
  border-bottom: 1px solid #989898;
  display: flex;
  font-weight: 700;
  gap: 10px;
  &.top {
    margin: 50px 0;
    font-size: 24px;
    color: #adadad;
    li {
      padding-bottom: 10px;
    }
  }
  &.sub {
    font-size: 16px;
    color: #6f6f6f;
    margin: 50px 0 0;
    li {
      text-align: center;
      padding-bottom: 20px;
    }
  }
  li {
    width: 100px;
    position: relative;
    transition: 0.3s;
    cursor: pointer;
    &::after {
      transition: 0.3s;
      position: absolute;
      content: "";
      height: 2px;
      width: 0;
      background: #0a0a0a;
      bottom: 0;
      left: 0;
      transform: translateY(100%);
    }
    &.active {
      &::after {
        width: 100%;
      }
      color: #333333;
    }
  }
  @media screen and (max-width: 1050px) {
    &.top {
      font-size: 20px;
    }
  }
  @media screen and (max-width: 767px) {
    &.top {
      font-size: 18px;
      li {
        width: calc(100% / 3);
      }
    }
    &.sub {
      font-size: 14px;
      li {
        width: 50%;
        padding-bottom: 10px;
      }
    }
  }
`;

export const CouponContainer = styled.div`
  font-size: 16px;
  .form {
    display: flex;
    align-items: center;
    gap: 15px;
    button,
    input[type="text"] {
      height: 50px;
      border-radius: 5px;
      border: none;
    }
    input[type="text"] {
      width: calc(100% - 155px);
      background: #eeeeee;
      padding: 0 20px;
      &:focus {
        border: none !important;
        box-shadow: none;
      }
    }
    button {
      width: 140px;
      background: #1a6cff;
      color: #fff;
    }
  }
  .coupon {
    li {
      min-height: 60px;
      padding: 5px 0;
      display: flex;
      text-align: center;
      align-items: center;
      border-bottom: 1px solid #989898;
      &.header {
        color: #a7a7a7;
      }
      &:not(:first-child) {
        .status {
          color: #1a6cff;
        }
      }
      .image {
        width: 100px;
        height: 40px;
        border-radius: 50%;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: calc(30% - 100px);
        strong {
          font-weight: normal;
          display: block;
        }
      }
      .type,
      .date,
      .status {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span {
        &.status {
          width: 10%;
        }
        &.type {
          width: 10%;
        }
        &.desc {
          width: 30%;
        }
        &.date {
          width: 20%;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 14px;
    .form {
      gap: 10px;
      input[type="text"] {
        width: calc(100% - 110px);
        height: 40px;
      }
      button {
        width: 100px;
        height: 40px;
      }
    }
    .coupon {
      overflow: hidden;
      padding-top: 20px;
      font-size: 12px;
      li {
        flex-direction: column;
        align-items: baseline;
        justify-content: center;
        padding-left: 120px;
        margin-bottom: 20px;
        min-height: 127px;
        border-radius: 5px;
        position: relative;
        border: 1px solid #d4d4d4;
        &::after {
          content: "";
          position: absolute;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          left: 100%;
          top: 50%;
          transform: translate(-40%, -50%);
          border: 1px solid #d4d4d4;
          z-index: 1;
          background: #fff;
        }
        &.header {
          display: none;
        }
        &:last-child {
          margin-bottom: 0;
          border-bottom: 1px solid #d4d4d4;
        }
        .image {
          position: absolute;
          top: 50%;
          left: 0;
          height: 80%;
          width: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          transform: translateY(-50%);
          border-right: 1px dashed #bbb;
          border-radius: 0;
          img {
            width: 80px;
            height: 80px;
            outline: 1px solid #d4d4d4;
            border-radius: 50%;
            overflow: hidden;
          }
        }
        .name {
          text-align: left;
          width: calc(100% - 30px);
          order: 1;
          font-size: 14px;
          font-weight: 500;
          strong {
            margin-bottom: 16px;
          }
          span {
            color: #333333;
            margin-bottom: 5px;
            display: block;
          }
        }
        span {
          text-align: left;
          &.cond,
          &.date {
            width: calc(100% - 30px);
          }
          &.issue,
          &.status,
          &.type {
            display: none;
          }
          &.desc {
            order: 3;
            color: #656565;
            width: calc(100% - 30px);
          }
          &.date {
            order: 2;
            color: #656565;
            margin-bottom: 3px;
          }
        }
      }
    }
  }
`;

export const CompanyInfoNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px auto 10px;
  gap: 10px;
  &.btnArea {
    button {
      color: #fff;
      width: 200px;
      background: #0074ca;
      padding: 10px 0;
      font-size: 16px;
    }
  }
`;

export const CreateReleaseNotesContainer = styled.div`
  min-height: calc(-540px + 100vh);
  color: rgb(0, 0, 0);
  box-sizing: border-box;
  position: relative;
  font-size: 16px;
  &.dark {
    color: #000;
    .ck button {
      color: #000;
    }
  }
  .content {
    box-sizing: border-box;
    max-width: 1040px;
    padding: 0 20px;
    margin: 50px auto;
    .ck-content {
      height: 500px;
    }
    input[type="text"] {
      border: 1px solid rgb(204, 206, 209);
      padding: 10px 15px;
      width: 100%;
      resize: none;
      margin-bottom: 10px;
    }
    .btnArea {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 50px;
      gap: 10px;
      button {
        padding: 10px 30px;
        border: 1px solid transparent;
        font-size: 16px;
        &:first-child {
          background: #0074ca;
          color: #efefef;
        }
      }
    }
  }
`;

export const DeleteLayerConainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 130px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  button {
    width: 300px;
    padding: 10px 0;
    border: none;
    border-radius: 30px;
    font-size: 15px;
    &:first-child {
      background: #1a6cff;
      color: #fff;
    }
    &:last-child {
      background: #eeeeee;
      color: #a7a7a7;
    }
  }
`;

export const NotifyBenefitContainer = styled.div`
  .my-masonry-grid {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-left: -30px;
    width: auto;
  }
  .my-masonry-grid_column {
    padding-left: 30px;
    background-clip: padding-box;
  }
  .box {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    border: 1px solid #efefef;
    padding: 15px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .store {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 15px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        outline: 1px solid #efefef;
        overflow: hidden;
        object-fit: cover;
      }
      span {
        &.name {
          font-weight: 700;
        }
        &:last-child {
          color: #999;
        }
      }
    }
    .product {
      display: flex;
      gap: 10px;
      .info {
        width: calc(100% - 110px);
        font-size: 14px;
        span {
          &:nth-child(1) {
            font-weight: 600;
          }
          &:nth-child(2) {
            display: block;
            margin: 5px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
          }
        }
        .tag {
          display: inline-block;
          padding: 3px;
          border: 1px solid #efefef;
          font-size: 12px;
          color: #0074ca;
        }
      }
      img {
        width: 100px;
        height: 100px;
        border-radius: 5px;
        overflow: hidden;
        object-fit: contain;
      }
    }
  }
`;

export const CompanyPageDashboard = styled.div`
  margin-top: 3%;
  button {
    border: none;
    background: transparent;
  }
  .inviteBtnArea {
    width: 100%;
    margin: 20px auto;
    text-align: right;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    input[type="text"] {
      padding: 0 10px;
      border: 1px solid #efefef;
      height: 100%;
    }
    button {
      padding: 10px 30px;
      font-size: 14px;
      background: #efefef;
    }
  }
  table {
    width: 100%;
    margin: auto;
    border: 1px solid #efefef;
    border-collapse: collapse;
    th,
    td {
      border: 1px solid #efefef;
    }
    thead {
      tr th {
        background: #0074ca;
        color: #fff;
        padding: 10px;
        font-size: 16px;
        border-right: 1px solid #efefef;
        &:last-child {
          border-right: none;
        }
      }
    }
    tbody {
      tr td {
        font-size: 14px;
        padding: 5px;
        text-align: center;
        select {
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          &:focus {
            box-shadow: none;
            border: none !important;
          }
        }
        button {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .inviteBtnArea {
      flex-wrap: wrap;
      button {
        padding: 10px 15px;
      }
    }
  }
`;

const fadeInOut = keyframes`
  0% { top: -100%; }  
  10% { top: 0; }      
  90% { top: 0; }     
  100% { top: -100%; } 
`;

export const InstallContainer = styled.div`
  &.dark {
    background: #000;
    .content button {
      background: #fff;
      color: #000;
    }
    .close {
      span {
        color: #ddd;
      }
      button {
        color: #fff;
      }
    }
  }
  z-index: 10000;
  width: 100vw;
  font-weight: 600;
  font-size: 16px;
  position: fixed;
  top: -100%;
  /* top: 0; */
  left: 50%;
  transform: translateX(-50%);
  transition: 0.3s;
  background: #fff;
  padding: 15px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  animation: ${fadeInOut} 10s forwards;
  .content {
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  button {
    border: none;
    width: max-content;
    padding: 5px 10px;
    border-radius: 5px;
    background: #000;
    color: #fff;
  }
  .close {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    span {
      color: #555;
      cursor: pointer;
    }
    button {
      border: none;
      background: transparent;
      color: #000;
      padding: 0;
      font-size: 20px;
    }
    svg {
      display: block;
    }
  }
  @media screen and (max-width: 767px) {
    border-radius: 0;
    width: 100%;
    font-size: 12px;
  }
`;

export const DashboardInfoContainer = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px 50px;
  .infoContent {
    position: relative;
    .overview,
    .themeWeatherWidget {
      button {
        display: flex;
        align-items: center;
        gap: 5px;
        background: transparent;
        border: none;
        &:first-child {
          margin-right: 20px;
        }
        svg {
          display: block;
        }
      }
    }
    .overview {
      font-size: 16px;
      text-align: right;
      letter-spacing: -1px;
      position: absolute;
      right: 0;
      top: 0;
      > span {
        display: block;
        &:first-child {
          font-size: 20px;
        }
      }
      .buttons {
        display: flex;
        margin: 30px 0;
      }
      .weather {
        display: flex;
        align-items: center;
        justify-content: end;
        .icon {
          margin-right: 5px;
          svg {
            display: block;
          }
        }
      }
    }
    .themeWeatherWidget {
      display: flex;
      align-items: center;
      justify-content: end;
    }
  }
  @media screen and (max-width: 767px) {
    padding: 0 20px 50px;
    .infoContent {
      display: flex;
      flex-wrap: wrap;
      .message {
        order: 1;
        width: 60%;
        strong {
          font-weight: 800;
        }
        span {
          &:first-child {
            font-size: 20px;
            display: block;
            margin-bottom: 15px;
          }
          &:last-child {
            font-size: 18px;
            font-weight: 500;
          }
        }
      }
      .overview {
        order: 2;
        width: 40%;
        position: relative;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        > span:first-child {
          font-size: 12px;
          order: 1;
        }
        .weather {
          order: 1;
        }
        .buttons {
          order: 3;
          margin: 0;
          flex-direction: column-reverse;
          align-items: end;
          gap: 5px;
          button {
            &:first-child {
              margin: 0;
            }
            span.icon {
              font-size: 16px;
            }
          }
        }
      }
      .themeWeatherWidget {
        flex-direction: column-reverse;
        align-items: end;
        gap: 5px;
        order: 2;
        button:first-child {
          margin-right: 0;
        }
      }
    }
  }
`;

export const DashboardContainer = styled.div`
  &.dark {
    .widget {
      .unreadNotifications,
      .mentions,
      .scheduler,
      .dday,
      .groupSchedule,
      .projects,
      .homepage,
      .company {
        background: #2c2d30;
        .info .label {
          color: rgba(255, 255, 255, 0.5);
        }
        .mySwiper .scheduleContent {
          background: #1e1f21;
        }
      }
      &.overlay {
        background: rgba(0, 0, 0, 0.7);
        .unreadNotifications,
        .mentions,
        .scheduler,
        .dday,
        .groupSchedule,
        .projects,
        .homepage,
        .company {
          background: transparent;
        }
      }
    }
  }
  .overlay {
    background: rgba(255, 255, 255, 0.7);
    /* border: 1px solid #ddd; */
    /* box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px; */
    height: auto;
    min-height: 150px;
    width: 100%;
    border-radius: 30px;
    padding: 0;
  }
  .widget:not(.overlay) {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    grid-auto-rows: minmax(150px, auto);
    gap: 30px;
    padding: 0 20px;
  }
  .widget {
    max-width: 1440px;
    margin: 0 auto;
    /* display: flex;
    flex-wrap: wrap; */

    font-size: 20px;
    .unreadNotifications,
    .mentions,
    .scheduler,
    .dday,
    .groupSchedule,
    .projects,
    .homepage,
    .company {
      background: rgba(255, 255, 255, 0.5);
      border-radius: 30px;
      padding: 30px;
      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 25px;
        .label {
          font-size: 28px;
          font-weight: 700;
          color: rgba(0, 0, 0, 0.5);
          display: inline-block;
          letter-spacing: -1px;
        }
        button {
          border: none;
          background: transparent;
          svg {
            display: block;
          }
        }
      }
    }
    .unreadNotifications {
      /* width: calc(50% - 15px); */
      width: 100%;
      ul {
        max-height: 150px;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 5px;
        }
        &::-webkit-scrollbar-thumb {
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: 5px;
        }
        &::-webkit-scrollbar-track {
          background-color: transparent;
        }
      }
      li {
        cursor: pointer;
        position: relative;
        margin-left: 10px;
        padding-left: 10px;
        margin-bottom: 16px;
        span {
          display: inline-block;
          max-width: 100%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        &::after {
          content: "";
          position: absolute;
          width: 10px;
          height: 10px;
          background: #6648ff;
          border-radius: 50%;
          top: 50%;
          left: -10px;
          transform: translateY(-50%);
        }
        &::before {
          content: "";
          position: absolute;
          width: 2px;
          height: 42px;
          background: #5c5c5c;
          border-radius: 50%;
          top: 120%;
          left: -6px;
          transform: translateY(-50%);
        }
        &:last-child::before {
          display: none;
        }
      }
    }
    .mentions {
      width: 100%;
    }
    .scheduler {
      width: 100%;
    }
    .dday {
      width: 100%;
    }
    .groupSchedule {
      width: 100%;
    }
    .projects {
      width: 100%;
    }
    .homepage {
      width: 100%;
      ul {
        max-height: 100px;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 0px;
        }
      }
      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        &:last-child {
          margin-bottom: 0;
        }
        span {
          cursor: pointer;
        }
        button {
          border: none;
          background: transparent;
        }
      }
    }
    .company {
      width: 100%;
    }
  }
  @media screen and (max-width: 767px) {
    .widget {
      &:not(.overlay) {
        grid-template-columns: repeat(2, minmax(150px, 1fr));
        gap: 20px;
      }
      .unreadNotifications,
      .mentions,
      .scheduler,
      .dday,
      .groupSchedule,
      .projects,
      .homepage,
      .company {
        width: 100%;
        font-size: 14px;
        padding: 20px;
        border-radius: 20px;
        .info {
          margin-bottom: 15px;
          .label {
            font-size: 18px;
          }
        }
      }
      .unreadNotifications ul {
        max-height: 140px;
        li::before {
          height: 38px;
        }
      }
    }
  }
`;

export const QuickLinkContainer = styled.div`
  max-width: 1440px;
  padding: 0 10px;
  height: 760px;
  display: flex;
  align-items: center;
  justify-content: center;
  .ellipse {
    width: 600px;
    position: relative;
    height: 600px;
    border: 0.5px solid #47474741;
    border-radius: 50%;
    .message {
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 28px;
      letter-spacing: -1px;
      span {
        display: block;
        strong {
          cursor: pointer;
          font-weight: 800;
        }
        &:first-child {
          font-weight: 300;
        }
        &:last-child {
          font-weight: 500;
          margin-top: 20px;
        }
      }
    }
    .shortcutItem {
      width: 77px;
      height: 100px;
      position: absolute;
      transform: translate(-50%, -50%);
      .shortcutItemContent {
        position: relative;
        height: 100%;
        .menuButton {
          position: absolute;
          top: 0;
          right: 0;
          background: transparent;
          border: none;
          font-size: 20px;
          opacity: 0;
          transition: 0.3s;
          transform: translateX(100%);
        }
        &:hover .menuButton {
          opacity: 1;
        }
        .shortcut {
          width: 100%;
          height: 100%;
          border: none;
          background: transparent;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          align-items: center;
          position: relative;
          img {
            width: 100%;
            height: calc(100% - 23px);
            filter: drop-shadow(rgba(0, 0, 0, 0.3) 4px 4px 3px);
          }
          .not {
            position: absolute;
            top: calc(50% - 11.5px);
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 40px;
            font-weight: 900;
            color: #000;
            text-transform: uppercase;
          }
          .label {
            width: 100%;
            display: inline-block;
            text-transform: capitalize;
            font-size: 20px;
            font-weight: 600;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    order: 3;
    position: relative;
    width: 100%;
    height: auto;
    margin-top: 40px;
    padding: 0;
    .ellipse {
      width: 100%;
      border: none;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      border-radius: 0;
      .shortcutItem {
        position: relative;
        transform: none;
        width: calc((100% - 80px) / 5);
        height: 70px;
        .shortcutItemContent {
          .shortcut {
            width: 100%;
            height: 100%;
            img {
              width: 100%;
              height: calc(100% - 20px);
              object-fit: contain;
              filter: drop-shadow(rgba(0, 0, 0, 0.3) 2px 2px 2px);
            }
            .label {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
`;

export const ScheduleSwiperContainer = styled.div`
  .mySwiper {
    width: 100%;
    height: 94px;
    &:last-child {
      margin-right: 0;
    }
    .scheduleContent {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 15px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.5);
      height: 94px;
      cursor: pointer;
      gap: 10px;
      justify-content: space-between;
      border-radius: 5px;
      &.outside::after {
        content: "";
        width: 5px;
        height: 94px;
        background: linear-gradient(180deg, rgba(0, 116, 202, 1) 0%, rgba(237, 85, 131, 1) 100%);
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 5px 0 0 5px;
      }
      .timeArea {
        font-size: 18px;
        font-weight: 700;
        text-align: center;
        width: 70px;
        .endOfStart,
        .projectType {
          display: block;
          font-size: 13px;
        }
        .ddayDate {
          font-weight: normal;
          font-size: 13px;
        }
      }
      .contentArea {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        width: calc(100% - 80px);
        span {
          &:nth-child(1) {
            font-size: 20px;
            font-weight: 500;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .mySwiper {
      height: 50px;
      .scheduleContent {
        padding: 10px;
        height: 50px;
        .timeArea {
          font-size: 12px;
          width: 50px;
          .projectType,
          .endOfstart {
            font-size: 10px;
          }
        }
        .contentArea {
          width: calc(100% - 55px);
          span:nth-child(1) {
            font-size: 12px;
          }
        }
      }
    }
  }
`;

export const MenuContainer = styled.div`
  width: 130px;
  position: fixed;
  transform: translate(-50%, 30px);
  z-index: 999;
  &.dark {
    .contextMenu {
      background: #141416;
      li:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }
  }
  ul {
    background: rgba(255, 255, 255, 0.9);
    border-radius: 5px;
    padding: 10px 0;
    li {
      font-size: 14px;
      letter-spacing: -1px;
      transition: 0.3s;
      cursor: pointer;
      padding: 5px 10px;
      &:hover {
        background: rgba(217, 217, 217, 0.5);
      }
    }
  }
  @media screen and (max-width: 767px) {
    transform: translate(-70%, 20px);
  }
`;

export const MakeShortcutsContainer = styled.div`
  &.dark {
    .buttons button {
      border: 2px solid transparent;
      border-radius: 31px;
      background: rgba(255, 255, 255, 0.5);
      color: #000;
    }
    .inputField .content label input {
      background: #d9d9d9;
    }
    .selectIcon .content div {
      img {
        filter: drop-shadow(rgba(255, 255, 255, 0.1) 2px 2px 1px)
          drop-shadow(rgba(255, 255, 255, 0.1) -2px 2px 1px)
          drop-shadow(rgba(255, 255, 255, 0.1) 2px -2px 1px)
          drop-shadow(rgba(255, 255, 255, 0.1) -2px -2px 1px);
      }
      .checkmark {
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
      }
    }
  }
  .content {
    height: calc(100% - 150px);
    font-size: 20px;
  }
  .buttons {
    height: 62px;
    display: flex;
    justify-content: end;
    gap: 15px;
    button {
      font-size: 24px;
      width: 112px;
      color: #0b57d0;
      border: 2px solid #0b57d0;
      border-radius: 31px;
      background: transparent;
      &:last-child {
        background: #0b57d0;
        color: #fff;
      }
    }
  }
  .inputField {
    .content {
      .input {
        margin-bottom: 38px;
        .info {
          margin-bottom: 15px;
          letter-spacing: -1px;
          display: flex;
          gap: 10px;
          align-items: flex-end;
        }
        /* &.url {
          position: relative;
          .fixed {
            position: absolute;
            bottom: 27.5px;
            left: 20px;
            transform: translateY(50%);
            z-index: 3;
            color: #000;
          }
        } */
        .monotiService {
          display: flex;
          align-items: center;
          gap: 10px;
          width: 200px;
          button {
            border: none;
            background: none;
            width: 35px;
            height: 35px;
          }
          img {
            width: 100%;
            height: 100%;
            filter: drop-shadow(rgba(0, 0, 0, 0.1) 1px 1px 1px)
              drop-shadow(rgba(0, 0, 0, 0.1) -1px 1px 1px)
              drop-shadow(rgba(0, 0, 0, 0.1) 1px -1px 1px)
              drop-shadow(rgba(0, 0, 0, 0.1) -1px -1px 1px);
          }
        }
        input {
          display: block;
          border: 1px solid #a9a9a9;
          border-radius: 19px 19px 0 0;
          width: 100%;
          height: 55px;
          padding: 0 20px;
          &:focus {
            border: 1px solid #d9d9d9 !important;
            box-shadow: none;
            background: #d9d9d9;
          }
        }
      }
    }
  }
  .selectIcon {
    .content {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      height: calc(100% - 200px);
      div {
        width: 86px;
        height: 86px;
        aspect-ratio: 1;
        background: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        .not {
          width: 86px;
          height: 86px;
          position: absolute;
          top: 50%;
          left: 50%;
          border-radius: 25%;
          transform: translate(-50%, -50%);
          font-size: 40px;
          font-weight: 900;
          color: #000;
          text-transform: uppercase;
        }
        .checkmark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: rgba(255, 255, 255, 0.5);
          font-size: 40px;
          color: #000;
          overflow: hidden;
          width: 100%;
          height: 100%;
          transition: 0.3s;
          opacity: 0;
          width: 97px;
          height: 97px;
          svg {
            display: block;
          }
        }
        &.active .checkmark {
          opacity: 1;
        }
      }
      img {
        width: 100%;
        height: 100%;
        filter: drop-shadow(rgba(0, 0, 0, 0.3) 4px 4px 3px);
      }
    }
  }

  @media screen and (max-width: 767px) {
    .modal {
      max-width: 90%;
      border-right: 20px;
      height: 400px;
      .modalContent {
        padding: 20px;
      }
      .label {
        font-size: 20px;
        height: 25px;
      }
      .buttons {
        height: 35px;
        button {
          font-size: 16px;
        }
      }
      .inputField .content {
        font-size: 16px;
        label {
          font-size: 16px;
          margin-bottom: 20px;
          input {
            height: 40px;
            border-radius: 10px 10px 0px 0px;
          }
        }
      }
      .selectIcon .content {
        height: calc(100% - 100px);
        div {
          width: 59px;
          height: 59px;
        }
      }
    }
  }
`;

export const TabMenu = styled.div`
  &.dark {
    ul {
      color: #eee;
      background: rgba(0, 0, 0, 0.5);
      li.active {
        background: rgba(37, 99, 235, 0.7);
      }
    }
  }
  max-width: 1440px;
  padding: 0 20px;
  margin: 0 auto 50px;
  ul {
    max-width: 1040px;
    margin: auto;
    box-sizing: border-box;
    letter-spacing: -1px;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.5);
    background: rgba(255, 255, 255, 0.5);
    padding: 10px;
    border-radius: 5px;
    li {
      transition: 0.3s;
      width: calc(100% / 3);
      display: inline-block;
      text-align: center;
      height: 65px;
      line-height: 65px;
      border-radius: 5px;
      cursor: pointer;
      &.active {
        background: #fff;
      }
    }
  }
  @media screen and (max-width: 767px) {
    ul {
      font-size: 14px;
      padding: 0;
      display: flex;
      gap: 10px;
      width: 100%;
      background: transparent;
      li {
        height: 35px;
        line-height: 35px;
        background: rgba(255, 255, 255, 0.5);
      }
    }
  }
`;

export const ChangeUserInfoFormContainer = styled.div`
  max-width: 1080px;
  padding: 0 20px;
  margin: 0 auto 50px;
  box-sizing: border-box;
  letter-spacing: -1px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 18px;
  &.dark {
    color: #eee;
    ul li input[type="text"],
    ul li input[type="password"] {
      background: rgba(0, 0, 0, 0.5);
      color: #eee;
    }
    ul li.email button,
    ul li.moblphonNo button {
      background: #000;
      color: #eee;
    }
  }
  > span {
    display: inline-block;
    margin-bottom: 20px;
  }
  input[type="file"] {
    display: none;
  }
  ul {
    li {
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
      &.imgPath {
        .writing_cont {
          position: relative;
          width: 150px;
          height: 150px;
          border: 1px solid #7d7371;
          border-radius: 10px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            opacity: 0.7;
          }
          .deleteBtn {
            position: absolute;
            top: 10px;
            right: 10px;
            border: none;
            background: transparent;
            svg {
              display: block;
            }
          }
          .notImage {
            height: 100%;
            font-size: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            svg {
              display: block;
            }
          }
        }
      }
      &.email,
      &.moblphonNo {
        .writing_cont {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        input[type="text"] {
          width: calc(100% - 180px);
        }
        button {
          border-radius: 30px;
          background: #fff;
          border: none;
          height: 50px;
          width: 160px;
          color: rgba(0, 0, 0, 0.5);
        }
      }
      .writing_tit {
        font-weight: 700;
        font-size: 22px;
        margin-bottom: 20px;
      }
      input[type="text"],
      input[type="password"] {
        width: 100%;
        border-radius: 10px;
        padding: 0 20px;
        height: 50px;
        border: none;
        background: rgba(255, 255, 255, 0.5);
        &:focus {
          border: none !important;
          box-shadow: none;
          outline: none;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 14px;
    > span {
      margin-bottom: 15px;
      font-size: 14px;
    }
    ul li {
      margin-bottom: 15px;
      &.email,
      &.moblphonNo {
        input[type="text"] {
          width: calc(100% - 100px);
        }
        button {
          width: 90px;
          height: 30px;
        }
      }
      .writing_tit {
        font-size: 16px;
        margin-bottom: 5px;
      }
      input[type="text"],
      input[type="password"] {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
      }
    }
  }
`;

export const MembershipWithdrawalContainer = styled.div`
  max-width: 1080px;
  padding: 0 20px;
  margin: 0 auto 50px;
  box-sizing: border-box;
  letter-spacing: -1px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 18px;
  &.dark {
    color: #eee;
  }
  > span {
    display: inline-block;
    margin-bottom: 20px;
  }
  .viewer {
    span {
      display: block;
      text-align: center;
    }
  }
  @media screen and (max-width: 767px) {
    > span {
      margin-bottom: 15px;
      font-size: 14px;
    }
    font-size: 16px;
  }
`;
